import { createSelector } from 'reselect';

import { naturalSortBy } from 'utils/sort';

import { selectFeeProviders, selectFeeTypes } from 'store/system/selectors';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanPrepaids = createSelector(
  selectLoanApplication,
  ({ loanPrepaids }) => loanPrepaids,
);

export const selectLoanPrepaidsInterestCredit = createSelector(
  selectLoanPrepaids,
  ({
    hasInterestCredit,
    interestCreditFundingDate,
    interestCreditNoteDate,
    interestCreditFirstPaymentDate,
    interestCreditRescissionDate,
    interestCreditDisbursementDate,
    manualDailyPrepaidInterest,
  }) => ({
    hasInterestCredit,
    interestCreditFundingDate,
    interestCreditNoteDate,
    interestCreditFirstPaymentDate,
    interestCreditRescissionDate,
    interestCreditDisbursementDate,
    manualDailyPrepaidInterest,
  }),
);

const selectLoanPrepaidsList = createSelector(
  selectLoanPrepaids,
  ({ prepaidLoanFees }) => prepaidLoanFees,
);

export const selectLoanFeePrepaids = createSelector(
  [selectLoanPrepaidsList, selectFeeTypes, selectFeeProviders],
  (loanPrepaids, feeTypes, feeProviders) =>
    naturalSortBy(
      loanPrepaids.map(({ feeTypeId, feeProviderId, ...prepaid }) => ({
        ...prepaid,
        feeTypeId,
        feeProviderId,
        feeName: feeTypes[feeTypeId]?.name,
        feeProviderName: feeProviders[feeProviderId]?.name,
        countTowardsApr: feeTypes[feeTypeId]?.countTowardsApr,
      })),
      'feeName',
    ),
);
